import { AUTH_HEADERS, HttpMethod } from '@libs/core';
import type { ActivateOffer, ActivateOfferResponse } from '@libs/common-types';
import { client } from '../../client';
import { getAccessToken } from '../../utils';
import { CWEA_ENDPOINTS } from '../../constants';

export async function activateOffer(offer: ActivateOffer) {
    const token = getAccessToken();

    if (!token) {
        return null;
    }

    const url = CWEA_ENDPOINTS.loyalty.activateOffer;
    return await client.cwea<ActivateOfferResponse>(url, {
        method: HttpMethod.POST,
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
        },
        body: JSON.stringify({
            activationPromoId: offer.activationPromoId.toString(),
            intType: offer.intType,
            memberDescriptor: offer.memberDescriptor,
            memberGroup: offer.memberGroup,
            offerId: offer.offerId,
            // [AC-1618]: will be controlled by BFF, can be removed once AC-1618 is complete
            sourceId: '2801',
            transactionType: offer.transactionType,
            version: offer.version,
        }),
    });
}
